import { render, staticRenderFns } from "./ResetRequest.vue?vue&type=template&id=30dbdd72&"
import script from "./ResetRequest.vue?vue&type=script&lang=js&"
export * from "./ResetRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports